import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {addHours} from 'date-fns';
import {Room} from '../../../../../+rooms/shared/models/room.class';
import {RoomService} from '../../../../../+rooms/shared/services/room/room.service';
import {User} from '../../../../../../../shared/models/user.class';
import {APIHelper} from '../../../../../../../shared/services/api-helper/api-helper.service';
import {EventCalendar} from '../../models/event-calendar.model';
import {EventService} from '../../providers/event.service';
import { DialogLookupUsersGroupsComponent } from 'src/app/+home/shared/components/dialog-lookup-users-groups/dialog-lookup-users-groups.component';
import * as moment from 'moment'
import { AGENCIES } from './shared/datas/dist/agencies';
import { MatStepper } from '@angular/material/stepper';


//declare let moment;

@Component({
  selector: 'app-dialog-add-resa',
  templateUrl: './dialog-add-resa.component.html',
  styleUrls: ['./dialog-add-resa.component.scss']
})
export class DialogAddResaComponent implements OnInit {
  public ariane;
  public loading: boolean;
  public loadingRequest: boolean;
  public file: any;
  public firstFormGroup: FormGroup;
  public secondFormGroup: FormGroup;
  public thirdFormGroup: FormGroup;
  // public minDate: Date;
  public dateWanted: Date;
  public errorCreneaux: string;
  public selectedName: string;
  public rooms: Room[];
  public isDisabledCreneaux: boolean;
  public errorMessage: string;
  public isEdit: boolean;
  public oldEvent: EventCalendar;
  public availableAgencies: string[] = AGENCIES;
  @ViewChild('stepper') stepper;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogAddResaComponent>,
    private api: APIHelper,
    private fb: FormBuilder,
    private roomService: RoomService,
    private dialog: MatDialog,
    private eventService: EventService,
  
  ) {}

  ngOnInit() {
    this.loading = false;
    this.loadingRequest = false;
    this.dateWanted = this.data.dateWanted;
    this.errorCreneaux = '';
    this.selectedName = '';
    this.isDisabledCreneaux = false;
    this.isEdit = false;

    if (this.data && this.data.isEdit) {
      this.isEdit = this.data.isEdit;
      this.oldEvent = this.data.event;
      this.selectedName = this.oldEvent.organiserFullname;
    }

    // this.minDate = new Date();

    this.firstFormGroup = this.fb.group({
      room: [
        this.isEdit ? this.oldEvent.idSalle.toString() : null,
        Validators.required
      ]
    });

    this.secondFormGroup = this.fb.group({
      who: [this.isEdit ? this.oldEvent.whatEvent : '', Validators.required],
      desc: [this.isEdit ? this.oldEvent.descriptionEvent : ''],
      date: [this.dateWanted, Validators.required]
    });

    this.thirdFormGroup = this.fb.group({
      creneaux: this.fb.array([])
    });

    // Ajouter un premier créneau obligatoire
    this.addCreneau();
    this.loadRooms();
  }

  checkCreneaux() {
    this.errorCreneaux = '';
    const creneaux = this.thirdFormGroup.get('creneaux') as FormArray;

    this.stepper.selectedIndex++;
    this.sendToServer();
  }

  addCreneau() {
    const creneaux = this.thirdFormGroup.get('creneaux') as FormArray;

    if (this.isEdit) {
      creneaux.push(
        this.fb.group({
          start: [this.oldEvent.fromDate, Validators.required],
          end: [this.oldEvent.toDate, Validators.required]
        })
      );
    } else {
      creneaux.push(
        this.fb.group({
          start: [
            this.data.showHour ? this.data.dateWanted : '',
            Validators.required
          ],
          end: [
            this.data.showHour ? addHours(this.data.dateWanted, 1) : '',
            Validators.required
          ]
        })
      );
    }
  }

  removeCreneau(index: number) {
    const creneaux = this.thirdFormGroup.get('creneaux') as FormArray;
    creneaux.removeAt(index);
  }

  onValidate() {
    this.loading = true;
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onOpenLookup() {
    const dialogRef = this.dialog.open(DialogLookupUsersGroupsComponent, {
      width: '60%',
      height: '45%'
    });

    dialogRef.afterClosed().subscribe((result: User) => {
      if (result) {
        // Ajout effectué
        this.selectedName = result.completeName;
        this.secondFormGroup.controls.who.setValue(result.id);
      }
    });
  }

  onChangeToggleAllDay(state: MatSlideToggleChange) {
    if (state.checked) {
      const today = this.dateWanted ? this.dateWanted : new Date();
      const start = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        8,
        0,
        0
      );
      const end = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        20,
        0,
        0
      );
      const control: any = this.thirdFormGroup.controls.creneaux;

      control.controls[0].controls.start.setValue(start);
      control.controls[0].controls.end.setValue(end);

      this.isDisabledCreneaux = true;
    } else {
      this.isDisabledCreneaux = false;
    }
  }

  private sendToServer() {
    this.loadingRequest = true;
        this.errorMessage = '';
        const editDate = this.secondFormGroup.value.date;
        let start = this.thirdFormGroup.value.creneaux[0].start;
        start.setMinutes(start.getMinutes()-30) ;
        start.setFullYear(editDate.getFullYear(), editDate.getMonth(), editDate.getDate());
        let end = this.thirdFormGroup.value.creneaux[0].end;
        end.setMinutes(end.getMinutes()+30);
      
        end.setFullYear(editDate.getFullYear(), editDate.getMonth(), editDate.getDate());

        const data = {
            fromDate: moment(start).format('YYYY-MM-DD HH:mm:ss'),
            toDate: moment(end).format('YYYY-MM-DD HH:mm:ss'),
            whatEvent: 'admin',
            descriptionEvent: this.secondFormGroup.value.desc,
            salle: +this.firstFormGroup.value.room
        };
        let promise = null;

        if (this.isEdit) {
            promise = this.eventService.editEvent(this.oldEvent.eventName, data);
        } else {
            promise = this.eventService.createEvent(data);
        }


        promise
            .then((res: EventCalendar) => {
                this.dialogRef.close(res);
            })
            .catch((err) => {
                this.errorMessage = "La combinaison horaire / salle choisis sont déjà occupés. Merci de bien vouloir modifier vos choix.\n"
                +"Pour faciliter votre réservation, nous vous invitons à retourner sur le calendrier";
            })
            .finally(() => {
                this.loadingRequest = false;
            });
  }

  private loadRooms() {
    this.loading = true;

    this.roomService.loadRooms().then((res: Room[]) => {
      this.rooms = res;
      this.loading = false;
    });
  }

  goBack(stepper: MatStepper){
      stepper.previous();
  }

  goForward(stepper: MatStepper){
      stepper.next();
  }
}
